import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/publicity_2.jpg";
import "./Article.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Card1 from "../Images/Gallery/IMG20221004143851.jpg";
import Card3 from "../Images/Gallery/Artboard 1.png";

function CIRCODULaboratory() {
  return (
    <div className="art-page">
      <SEO
        title="CIRCODU Laboratory a Leader in Testing Cookstoves"
        description="CIRCODU's laboratory is a Regional Knowledge and Testing Centre for evaluating cookstove efficiency, safety, and emissions."
        keywords="CIRCODU, cookstove testing, indoor air quality, clean cooking, sustainable development, Uganda, Regional Knowledge and Testing Centre, UNBS certification, ISO/IEC 17025:2017, cookstove durability, thermal efficiency, safety testing, emissions testing, controlled cooking tests, charcoal cookstoves, firewood cookstoves, briquette cookstoves, electric pressure cookers, cookstove manufacturers, cookstove suppliers, consumer choices, indoor air pollution reduction"
        url="/CIRCODU-Laboratory-a-Leader-in-Testing-Cookstoves-for-Efficiency-Safety-Durability-and-Emissions"
        image={Card1}
        datePublished="2024-05-31"
      />

      {/* ── Hero ──────────────────────────────────────── */}
      <div className="art-hero">
        <div className="art-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="art-hero__overlay">
          <h4 className="art-hero__label">News &amp; Events</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Publicity</Breadcrumb.Item>
            <Breadcrumb.Item
              className="text1"
              href="/publicity/news-and-events"
            >
              News &amp; Events
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              CIRCODU Laboratory a Leader in Testing Cookstoves
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      {/* ── Article body ──────────────────────────────── */}
      <section className="art-section border-bottom">
        <div className="container">
          <div className="art-content">
            {/* Date */}
            <div className="art-date">
              <span className="art-date__dot" />
              May 31, 2024
            </div>

            {/* Title */}
            <h1 className="art-title">
              CIRCODU Laboratory a Leader in Testing Cookstoves for Efficiency,
              Safety, Durability, and Emissions
            </h1>

            {/* Body */}
            <div className="texty">
              <img
                src={Card3}
                alt="CIRCODU Cookstove Laboratory overview"
                className="art-img"
              />

              <p>
                The Centre for Integrated Research and Community Development
                Uganda (CIRCODU) laboratory is a Regional Knowledge and Testing
                Centre (RKTC) in testing cookstoves for efficiency, safety, and
                emissions. Since its establishment in 2010, the laboratory has
                become a knowledge hub for testing, improving and evaluating
                cookstoves. The laboratory promotes cleaner cooking solutions
                that safeguard human health and the environment throughout East
                Africa.
              </p>

              <h2 className="art-subheading">A Regional Hub of Excellence</h2>
              <p>
                Recognized as a Regional Knowledge and Testing Centre by
                international and national standards bodies, including
                certification from the Uganda National Bureau of Standards
                (UNBS/LRS/0023) and compliance with ISO/IEC 17025:2017, the
                laboratory is pivotal in upholding rigorous standards for
                cookstove testing.
              </p>

              <h2 className="art-subheading">
                Impressive Milestones and Collaborations
              </h2>
              <p>
                Over the past decade, the laboratory has tested, monitored and
                evaluated over 50,000 cookstoves for different clients,
                facilitating a widespread adoption of improved cookstoves across
                Uganda and the East African region.
              </p>

              <h2 className="art-subheading">
                Comprehensive Testing Activities
              </h2>
              <p>
                The Laboratory conducts a variety of tests on cookstoves and
                fuels, including:
              </p>
              <ol>
                <li>
                  <strong>Durability Tests:</strong> Assessing the lifespan of
                  cookstoves under normal use.{" "}
                  <em style={{ color: "var(--art-red)" }}>
                    "How long will a cookstove last?"
                  </em>
                </li>
                <li>
                  <strong>Thermal Efficiency Tests:</strong> Measures how
                  efficiently a cookstove converts fuel into cooking heat.{" "}
                  <em style={{ color: "var(--art-red)" }}>
                    "How efficiently does the cookstove convert fuel into heat
                    for cooking?"
                  </em>
                </li>
                <li>
                  <strong>Safety Tests:</strong> Identifying potential hazards
                  during and/or associated with cookstove use.{" "}
                  <em style={{ color: "var(--art-red)" }}>
                    "Are there any hazards associated with using the cookstove?"
                  </em>
                </li>
                <li>
                  <strong>Controlled Cooking Tests:</strong> Evaluates how much
                  fuel is needed to cook a specific meal in a real-world cooking
                  scenario.{" "}
                  <em style={{ color: "var(--art-red)" }}>
                    "How much fuel is required to cook a typical meal?"
                  </em>
                </li>
                <li>
                  <strong>Emissions Testing:</strong> Measuring pollutants such
                  as carbon dioxide, carbon monoxide, and particulate matter
                  released during cooking.{" "}
                  <em style={{ color: "var(--art-red)" }}>
                    "Does the cookstove release harmful gases or pollutants?"
                  </em>
                </li>
              </ol>

              <p>
                These tests are applied to various cookstove technologies using
                different fuels including charcoal, firewood, briquettes, and
                electricity (notably electric pressure cookers).
              </p>

              <img
                src={Card1}
                alt="CIRCODU Laboratory cookstove testing in progress"
                className="art-img"
              />

              <h2 className="art-subheading">
                Impact on Cookstove Manufacturers, Suppliers, and Consumer
                Choices
              </h2>
              <p>The Laboratory's work has had a significant impact:</p>
              <ol>
                <li>
                  By providing reliable testing data, they help manufacturers
                  design and develop better cookstoves: cleaner, safer, and more
                  efficient.
                </li>
                <li>
                  The data also helps suppliers and consumers choose cookstoves
                  that meet their needs.
                </li>
                <li>
                  In addition, the Lab's work informs decisions on how to reduce
                  harmful emissions and improve indoor air quality, especially
                  protecting women and children who are most affected by
                  traditional cooking methods.
                </li>
              </ol>
            </div>

            {/* CTA */}
            <div className="art-cta">
              <p>
                Are you interested in getting your Cookstoves Tested, Monitored
                and Evaluated? CIRCODU has the expertise and equipment to test
                Cookstove Efficiency, Safety, Durability, and Emissions. Contact
                the Laboratory at{" "}
                <a href="mailto:info@circodu.org.ug">info@circodu.org.ug</a> or
                call us on <a href="tel:+256392004309">+256 (0) 392 004 309</a>{" "}
                / <a href="tel:+256782433627">+256 (0) 782 433 627</a>
              </p>
            </div>

            {/* Back */}
            <a href="/publicity/news-and-events" className="art-back">
              ← Back to News &amp; Events
            </a>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CIRCODULaboratory;
